import type { ReportDefinitionSummary } from './api';
import { ReportSchedule } from './report-schedule';

/** O que a linha sem envio diz: quando sai o primeiro, ou por que ainda não sai. */
export class ReportSendsEmptyNote {
  static of(definition: ReportDefinitionSummary, now: Date): string {
    if (definition.status === 'paused') return 'Nenhum envio ainda. A linha está pausada: nada sai até ela voltar a ficar ativa.';
    const next = new ReportSchedule(definition.schedule).nextSend(now);
    if (!next) return 'Nenhum envio ainda. A linha não tem próximo horário.';
    return `Nenhum envio ainda. O primeiro sai em ${next.label}.`;
  }
}
